var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M.428 21.541a1.585 1.585 0 0 1 .014-2.182L8.4 11.2.442 3.04A1.585 1.585 0 0 1 .428.86 1.447 1.447 0 0 1 2.53.845l9.03 9.257c.282.29.441.685.441 1.098s-.16.808-.442 1.098L2.53 21.555a1.447 1.447 0 0 1-2.1-.014"
  })));
};
export default SvgRightArrow;